import { render } from "./INPUTPREX.vue?vue&type=template&id=7f58d670&scoped=true"
import script from "./INPUTPREX.vue?vue&type=script&lang=js"
export * from "./INPUTPREX.vue?vue&type=script&lang=js"

import "./INPUTPREX.vue?vue&type=style&index=0&id=7f58d670&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f58d670"]])

export default __exports__